{
 "_note": "Regionale Wörter unter den Namen der Produkte (H6): Name → Region (AT Österreich, CH Schweiz, regional für Gegenden in Deutschland). Eine Anzeige kann sie durch den ersten Namen des Produkts ersetzen (displayName, standardWords); andere Synonyme wie „Fleischtomate“ bleiben. Gepflegt hier, bis der Katalog nach H4 hier liegt; jeder Name muss ein Name seines Produkts sein (Test).",
 "names": {
  "tomate": {"Paradeiser":"AT"},
  "johannisbeere": {"Ribisel":"AT","Träuble":"regional"},
  "aprikose": {"Marille":"AT"},
  "pflaume": {"Zwetschke":"AT"},
  "zucchini": {"Zucchetti":"CH"},
  "aubergine": {"Melanzani":"AT"},
  "karotte": {"Rübli":"CH","Gelbe Rübe":"regional"},
  "kartoffel": {"Erdapfel":"AT","Grumbeere":"regional"},
  "fruehlingszwiebel": {"Schlotten":"regional"},
  "blumenkohl": {"Karfiol":"AT"},
  "rosenkohl": {"Kohlsprossen":"AT"},
  "weisskohl": {"Weißkraut":"regional"},
  "rotkohl": {"Rotkraut":"regional","Blaukraut":"regional"},
  "feldsalat": {"Rapunzel":"regional","Nüsslisalat":"CH","Vogerlsalat":"AT"},
  "meerrettich": {"Kren":"AT"},
  "rote-bete": {"Rande":"CH"},
  "pfifferlinge": {"Eierschwammerl":"AT"},
  "gruene-bohnen": {"Fisolen":"AT"},
  "broetchen": {"Semmel":"AT","Semmeln":"AT","Kaisersemmel":"AT","Schrippe":"regional","Weck":"regional","Weckle":"regional","Wecken":"regional","Rundstück":"regional","Weggli":"CH"},
  "brezel": {"Breze":"regional","Brezn":"regional"},
  "croissant": {"Gipfeli":"CH","Kipferl":"AT"},
  "berliner": {"Krapfen":"AT"},
  "quark": {"Topfen":"AT"},
  "sahne": {"Rahm":"regional","Schlagrahm":"regional","Obers":"AT","Schlagobers":"AT"},
  "hackfleisch": {"Faschiertes":"AT","Gehacktes":"regional","Hackepeter":"regional"},
  "haehnchen": {"Hendl":"AT","Poulet":"CH","Pouletbrust":"CH"},
  "haxe": {"Stelze":"AT"},
  "wuerstchen": {"Wienerle":"regional","Wienerli":"CH","Saitenwürstchen":"regional"},
  "leberkaese": {"Leberkäs":"regional","Fleischkäse":"regional"},
  "lyoner": {"Extrawurst":"AT"},
  "frikadellen": {"Buletten":"regional","Fleischpflanzerl":"regional","Fleischküchle":"regional"},
  "puderzucker": {"Staubzucker":"AT"},
  "salzstangen": {"Salzstangerl":"AT"},
  "gummibaerchen": {"Gummibärli":"CH"},
  "radler": {"Alsterwasser":"regional"}
 }
}
